// extracted by mini-css-extract-plugin
module.exports = {"button":"Message__button___2zq80","title":"Message__title___YWpP9","annotation":"Message__annotation___bXcjW"};